<div class="workflow-kanban-wrapper-container">
    <tam-workflow-kanban-screen [screenId]="screenId" [id]="id" [taskId]="taskId" [instanceId]="instanceId"
        [actionSubject$]="actionSubject$" [isShowAsTab]="false" [firstPageTabId]="workflowView"
        [loadingSpecificScreen]="false" [pageId]="workflowView">
    </tam-workflow-kanban-screen>
</div>